<section>
  <nav  class="navbar navbar-expand-lg fixed-top" [ngClass]="{ 'navbar-scrolled': isScrolled || background }" >
    <div class="container">
      <a class="col-5 col-md-4 col-lg-2" href="/home">
        <img class="img-fluid" src="/assets/images/home/logo_medium.png" />
      </a>
      <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <ul class="navbar-nav menuHome mb-2 mb-lg-0">
          <!-- <li class="nav-item">
              <a class="nav-link text-white active" aria-current="page" href="/home" >Início</a >
          </li> -->
          <li class="nav-item invisivel">
              <a class="nav-link text-white" [routerLink]="['/about']">Sobre</a>
          </li>
          <li class="nav-item invisivel">
              <a class="nav-link text-white" href="/home">Metodologia</a>
          </li>
      <li class="nav-item invisivel">
        <a class="nav-link text-white" [routerLink]="['/contato']">Contato</a>
      </li>
      <li class="nav-item invisivel">
        <a class="nav-link text-white" href="/home">FAQ</a>
      </li>
    </ul>
    <select [(ngModel)]="selectedAdminId" (change)="onSelectionChange($event)" class="custom-select me-3">
      <option *ngFor="let admin of administrationList" [value]="admin.id">
        {{ admin.name }}
      </option>
    </select>
      <a class="nav-link text-white me-3" (click)="logout()" style="cursor: pointer;">Sair</a>
    </div>
      <div class="col-5 col-md-4 col-lg-2">
        <img class="img-fluid" src="/assets/images/home/Logo_SEP_Branco.png" />
      </div>
    <a class="btn navbar-toggler border-0" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" role="button" aria-controls="navbarNavDropdown" [innerHtml]="menuButton"></a>
    </div>
  </nav>
</section>
